import React from "react";
import { useTranslation } from "react-i18next";

function Contact() {
  const { t } = useTranslation();

  return (
    <main className="page">
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>{t("nav.contact")}</h1>
          <p>Liên hệ với chúng tôi</p>
        </div>
      </section>

      <section className="page-container">
        <p>Trang liên hệ - Nội dung sẽ được cập nhật</p>
      </section>
    </main>
  );
}

export default Contact;
